// Single source of truth for the live Assignoo backend.
// All API calls go to `${API_ORIGIN}/api/...` — same as the mobile app.
export const API_ORIGIN = "https://productivity-pro-102.emergent.host";
export const API_BASE = `${API_ORIGIN}/api`;

// Emergent-managed Google sign-in (same flow as the mobile app's web build)
export const GOOGLE_AUTH_URL = "https://auth.emergentagent.com/";

// Push relay VAPID public key (SuprSend / Emergent managed push).
// While empty, the app still shows in-browser desktop notifications via polling
// whenever Assignoo is open (even in a background tab). Set this key to enable
// true closed-tab web push — no other changes needed.
export const VAPID_PUBLIC_KEY = "";
